import { useLocalStorageState } from "src/hooks/use_local_storage_state"

import { PREFIX, SELECTED_LAYOUT } from "../storage_keys"

export const useSelectedLayout = () =>
  useLocalStorageState(PREFIX, SELECTED_LAYOUT)
